import React from 'react';

export type UpgradeSurfaceProps = {
  className?: string;
};

/**
 * Non-entitled commissioner surface during the pilot allowlist era.
 * No checkout, pricing, or Stripe — entitlement is env allowlist only.
 *
 * // BACKEND-DEP: real purchase/checkout flow (post-pilot; pricing TBD). This placeholder is the drop-in seam.
 */
const UpgradeSurface: React.FC<UpgradeSurfaceProps> = ({ className }) => {
  return (
    <div className={className} data-testid="rtts-upgrade-surface">
      <p className="text-sm text-secondary-300" data-testid="rtts-upgrade-copy">
        RTTS is coming to your league soon
      </p>
      {/* No checkout affordance — pilot entitlement is LSC_RTTS_PILOT_LEAGUE_IDS. */}
    </div>
  );
};

export default UpgradeSurface;
